import { styled } from "styled-components";

import { colorCSS, fontSizes, theme } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const NavLinkAnchor = styled.a<{
    hoverColorInitial?: string;
}>(
    {
        display: "block",
        padding: "1rem",
        textAlign: "left",
        textDecoration: "none"
    },
    ({ hoverColorInitial }) =>
        hoverColorInitial &&
        `
  &:active {
    background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
  }

  &:focus:focus-visible {
    background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
  }

  @media (min-width: 992px) {
    &:hover {
      background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
      transition: background-color 0.3s ease;
    }
  }
  `
);

export const NavIcon = styled.div<{
    iconColorInitial?: string;
}>({
    svg: {
        "path, rect": {
            fill: ({ iconColorInitial }) =>
                iconColorInitial
                    ? colorCSS(`${iconColorInitial}100`)
                    : colorCSS(`N100`)
        },
        "height": "1.2rem",
        "width": "auto"
    },
    padding: "0.14rem 0.71rem 0 0.15rem"
});

export const NavLinkTitleContainer = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("line-height", "1rem")}
    ${redundantCssFromKebab("padding-bottom", "0.6rem")}
`;

export const NavLinkTitle = styled.p`
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("font-family", `${theme.fontFamily.text}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("font-weight", "normal")}
    ${redundantCssFromKebab("line-height", "1.5rem")}
    ${redundantCssFromKebab("margin", "0 !important")}
    ${redundantCssFromKebab("padding-right", "0.3rem")}
`;

export const NavLinkDescription = styled.div`
    p {
        ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
        ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
        ${redundantCssFromKebab("line-height", "1rem")}
        ${redundantCssFromKebab("margin", "0 !important")}
    }
`;
